import React, { useState } from 'react';
import { Rocket, X, ExternalLink } from 'lucide-react';

const DISMISSED_KEY = 'bchnostr:bch-launch-card-dismissed';

/**
 * Small, dismissible discovery card promoting BCH Launch (bchlaunch.com) — the
 * ecosystem's build-your-own-site product. Sits in the feed's discovery zone.
 * Dismissal is remembered in localStorage so it never nags.
 */
export default function BCHLaunchCard() {
  const [dismissed, setDismissed] = useState(() => {
    try { return localStorage.getItem(DISMISSED_KEY) === '1'; } catch { return false; }
  });

  if (dismissed) return null;

  const handleDismiss = () => {
    setDismissed(true);
    try { localStorage.setItem(DISMISSED_KEY, '1'); } catch { /* ignore */ }
  };

  return (
    <div
      className="mx-2 sm:mx-0 mb-3 rounded-xl border border-primary/20 bg-primary/5 overflow-hidden"
      style={{ contain: 'content' }}
    >
      <div className="flex items-center gap-3 px-4 py-3">
        <div className="w-9 h-9 rounded-xl bg-primary/10 flex items-center justify-center shrink-0">
          <Rocket className="w-5 h-5 text-primary" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold text-foreground">Need your own website?</p>
          <p className="text-xs text-muted-foreground mt-0.5">
            Launch a Bitcoin Cash site or project at bchlaunch.com.
          </p>
        </div>
        <a
          href="https://bchlaunch.com"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-primary text-primary-foreground text-xs font-bold hover:bg-primary/90 transition-colors shrink-0"
        >
          Launch <ExternalLink className="w-3.5 h-3.5" />
        </a>
        <button
          onClick={handleDismiss}
          className="p-1 rounded-lg hover:bg-muted transition-colors shrink-0"
          title="Dismiss"
          aria-label="Dismiss"
        >
          <X className="w-4 h-4 text-muted-foreground" />
        </button>
      </div>
    </div>
  );
}
